import { RadioCircle, RadioCircleMarked } from '@styled-icons/boxicons-regular';
import { StyledOptionsPage } from './OptionsPage.styled';
import useOptionsPage from './useOptionsPage.hook';
import AudioPlayPauseButton from '../../components/AudioPlayPauseButton/AudioPlayPauseButton';
import { Button } from 'antd';
import { getRandomInteger } from '@/modules/gameUtils/random';
import AnswerFeedback from '../../components/AnswerFeedback/AnswerFeedback';
import TextWithTranslations from '../../components/TextWithTranslations/TextWithTranslations';

const feedbackAudios = {
  correct: ['bien', 'bravo', 'muybien', 'perfecto'],
  incorrect: ['oo', 'oooo'],
};

export default function OptionsPage({
  page,
  folder,
  language,
  activityActions,
}) {
  const feedbackSoundsFolder = `${
    process.env.NEXT_PUBLIC_CLOUDFRONT_STATIC_HOST
  }/commonGameAssets/classic/sounds${language == 'es' ? '' : `/${language}`}`;

  let { options, multiple } = page.data;
  const { state, actions } = useOptionsPage({
    page,
    options,
    multiple,
    activityActions,
  });
  const cloudFolder = `${process.env.NEXT_PUBLIC_AWS_CLOUDFRONT_HOST}/${folder}`;
  return (
    <StyledOptionsPage className="page">
      <div className="text">
        {page.data.audio ? (
          <AudioPlayPauseButton
            size="large"
            src={`${cloudFolder}/${page.data.audio}`}
            className="audio-player"
            doPlay
          />
        ) : null}
        {page.data.text}
      </div>

      <div className="options">
        {page.data.options.map((option) => {
          const audio = option.audio || `audios/${page.id}-${option.id}.mp3`;
          const audioSrc = `${cloudFolder}/${audio}`;
          const value = state.selectedOptions.find(
            (o) => o.id == option.id
          )?.value;
          return (
            <div key={option.id} className="option-with-audio">
              {multiple ? (
                <div className="option">
                  <div className="option-text">
                    <TextWithTranslations
                      text={option.text}
                      translations={option.translations}
                    />
                  </div>
                  <div className="true-false">
                    <div className="btn-wrap-true">
                      <Button
                        size="large"
                        className={`true ${value ? 'selected' : ''}`}
                        onClick={
                          state.answered
                            ? null
                            : () => actions.onChange(option.id, true)
                        }
                      >
                        True
                      </Button>
                    </div>
                    <div className="btn-wrap-false">
                      <Button
                        size="large"
                        className={`false ${value === false ? 'selected' : ''}`}
                        onClick={
                          state.answered
                            ? null
                            : () => actions.onChange(option.id, false)
                        }
                      >
                        False
                      </Button>
                    </div>

                    <AnswerFeedback
                      className="feedback"
                      allAnswered={state.answered}
                      allCorrect={state.correct}
                      correct={
                        (option.correct && value) || (!option.correct && !value)
                      }
                    />
                  </div>
                </div>
              ) : (
                <div
                  className="option"
                  onClick={
                    !state.answered ? () => actions.onChange(option.id) : null
                  }
                >
                  <div className="option-text">
                    <TextWithTranslations
                      text={option.text}
                      translations={option.translations}
                    />
                  </div>
                  <RadioIcon
                    selected={state.selectedOptions.includes(option.id)}
                  />
                  <AnswerFeedback
                    className="feedback"
                    allAnswered={state.answered}
                    allCorrect={state.correct}
                    correct={option.correct}
                  />
                </div>
              )}
              <AudioPlayPauseButton
                size="large"
                src={audioSrc}
                className="audio-player"
              />
            </div>
          );
        })}
      </div>
      {state.answered && (
        <AudioPlayPauseButton
          noGUI
          src={`${feedbackSoundsFolder}/${
            state.correct
              ? feedbackAudios.correct[
                  getRandomInteger(0, feedbackAudios.correct.length - 1)
                ]
              : feedbackAudios.incorrect[
                  getRandomInteger(0, feedbackAudios.incorrect.length - 1)
                ]
          }.mp3`}
          doPlay
        />
      )}
    </StyledOptionsPage>
  );
}

function RadioIcon({ selected }) {
  const Icon = selected ? RadioCircleMarked : RadioCircle;
  return (
    <div>
      <Icon className="option-icon" size={60} />
    </div>
  );
}
